export default function (state) {
    state.Name = '';
    state.FirstName = '';
    state.MiddleName = '';
    state.Birthday = '';
    state.PassportSeries = '';
    state.PassportNumber = '';
    state.AgreementCode = '';
    state.IsInternationalPassport = false;
    state.FullConditions = false;
}